<div class="object-lookup">
  <mat-form-field *ngIf="isSearching" appearance="outline" class="full-width">
    <mat-label>{{label}}</mat-label>
    <input matInput
           [(ngModel)]="searchTerm"
           (ngModelChange)="onSearch($event)"
           placeholder="Search"
           autocomplete="off" />
  </mat-form-field>

  <div *ngIf="selectedObject && !isSearching" class="selected-wrapper">
    <div class="selected-label">{{ label }}</div>
    <div class="selected-object-details" (click)="enterSearchMode()">
      <ng-container *ngTemplateOutlet="itemTemplate; context:{ item: selectedObject }"></ng-container>
    </div>
  </div>

  <div *ngIf="!selectedObject && !isSearching" class="no-selection">
    <div class="selected-label">{{ label }}</div>
    <div class="no-selection-controls">
      <button mat-stroked-button color="primary" (click)="enterSearchMode()">Search</button>
    </div>
  </div>

  <div class="results" *ngIf="isSearching && searchResults?.length">
    <div class="result-item"
         *ngFor="let item of searchResults"
         [class.selected]="getObjectId(item) === getObjectId(selectedObject)"
         (click)="selectObject(item)">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { item: item }"></ng-container>
    </div>
  </div>
</div>

<ng-template #itemTemplate let-item="item">
  <div class="detail-line">
    <strong class="detail-name">{{ getObjectName(item) }}</strong>
    <span class="detail-id">ID: {{ getObjectId(item) }}</span>
  </div>
</ng-template>
